import { Button, Icon, Modal, Radio } from 'antd';
import { Panel } from 'components/ui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Enums from 'utils/EnumsManager';
import { Actions, FolderTable, SharedTo } from '../components';
import { tryFetchFilesByFolderId } from '../flow/actions';

const RadioGroup = Radio.Group;
const { ObjectTypes, REPORTS } = Enums;
const TYPES = [
  ObjectTypes.Leads,
  ObjectTypes.Accounts,
  ObjectTypes.Opportunities
];
const TYPE_REPORT = REPORTS.FOLDER_TYPES.REPORT;
const TYPE_DASHBOARD = REPORTS.FOLDER_TYPES.DASHBOARD;

const defaultProps = {
  activeFolder: {}
};
const propTypes = {
  activeFolder: PropTypes.object
};

class ReportListPanel extends Component {
  constructor() {
    super();
    this.state = {
      visible: false,
      value: TYPES[0]
    };
  }
  componentDidUpdate(prevProps) {
    const { activeFolder, tryFetchFilesByFolderId } = this.props;
    if (
      !_.isEmpty(activeFolder) &&
      prevProps.activeFolder.id !== activeFolder.id
    ) {
      tryFetchFilesByFolderId(activeFolder.id, activeFolder.type);
    }
  }
  handleAddNewClick = () => {
    const { activeFolderType } = this.props;
    if (activeFolderType === TYPE_REPORT) {
      this.setState({ visible: true });
    }
  };
  handleValueChange = e => this.setState({ value: e.target.value });
  handleCancelClick = () =>
    this.setState({
      visible: false,
      value: TYPES[0]
    });
  handleOkClick = (value, folderId) =>
    this.props.history.push(`/reports/report-setup/${value}/new?folderId=${folderId}`);
  renderActionByType = type => {
    const { activeFolder } = this.props;
    const shouldDisabled = _.isEmpty(activeFolder);
    if (type === TYPE_REPORT) {
      return (
        <Button
          onClick={this.handleAddNewClick}
          size="small"
          className="report-theme-btn"
          disabled={shouldDisabled}
        >
          <Icon type="plus" className="font-sm mr-sm" />
          <FormattedMessage id="page.ReportListPanel.newReport" />
        </Button>
      );
    } else if (type === TYPE_DASHBOARD) {
      return (
        <Button
          size="small"
          className="report-theme-btn"
          disabled={shouldDisabled}
        >
          <Link
            to={`/dashboardFolders/${activeFolder.id}/dashboards/-1/settings`}
          >
            <Icon type="plus" className="font-sm mr-sm" />
            <FormattedMessage id="page.ReportListPanel.newDashboard" />
          </Link>
        </Button>
      );
    }
    return null;
  };

  render() {
    const { visible, value } = this.state;
    const { activeFolder, activeFolderType } = this.props;

    return (
      <Panel
        panelTitle={activeFolder.name}
        panelClasses="report-theme-panel"
        contentClasses="pt-md pr-lg pb-lg pl-lg"
        actionsRight={this.renderActionByType(activeFolderType)}
      >
        <FolderTable
          isSharedByOthers={!!activeFolder.sharedBy}
          activeFolderType={activeFolderType}
        />
        <div className="pb-md" />
        <SharedTo />
        <Actions activeFolder={activeFolder} />
        <Modal
          title={<FormattedMessage id="page.ReportListPanel.newReport" />}
          visible={visible}
          onOk={() => this.handleOkClick(value, activeFolder.id)}
          onCancel={this.handleCancelClick}
        >
          <h2>
            <FormattedMessage id="page.ReportListPanel.chooseType" />
          </h2>
          <RadioGroup onChange={this.handleValueChange} value={value}>
            {TYPES.map(t => (
              <Radio key={t} value={t}>
                <FormattedMessage id={`global.properNouns.${t}`} />
              </Radio>
            ))}
          </RadioGroup>
        </Modal>
      </Panel>
    );
  }
}

const mapStateToProps = ({ reportList }) => ({
  activeFolder: [
    ...reportList.folders.report,
    ...reportList.folders.dashboard
  ].find(f => f.isActive),
  activeFolderType: reportList.folders.activeTab
});
const mapDispatchToProps = {
  tryFetchFilesByFolderId
};
ReportListPanel.defaultProps = defaultProps;
ReportListPanel.propTypes = propTypes;
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReportListPanel)
);



// WEBPACK FOOTER //
// ./src/views/ReportListPanel/container/index.jsx